export default {
	state: {
		metadata: {
			theme: {
				primaryColor: "#fff", // Prevent flicker when tenant theme is loaded
				secondaryColor: "#fff"
			}
		},
		languages: ["en"],
		loaded: false,
		error: undefined,
		name: "",
		logo: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" // Empty image
	},
	mutations: {
		loadTenant(state, tenantData) {
			state.metadata = tenantData.metadata;
			state.languages = Object.keys(tenantData.metadata.messages);
			state.logo = tenantData.logo_base_64;

			state.loaded = true;
			state.error = undefined;
			state.name = tenantData.name;
		},
		startFetch(state) {
			state.loaded = false;
			state.error = undefined;
		},
		error(state, payload) {
			state.error = payload;
			state.loaded = false;
		}
	},
	actions: {
		async fetchTenant({ commit, getters }, tenantName) {
			if (getters.loaded && getters.tenantName === tenantName) return Promise.resolve();

			commit("startFetch");
			try {
				const http = await fetch(`${process.env.API}/tenants/${tenantName}`);
				if (!http.ok) {
					throw new Error(`Http error ${http.status}`);
				}
				const tenantData = await http.json();

				if (!tenantData.metadata) throw new Error(`Missing tenant data`);

				commit("loadTenant", tenantData);
			} catch (e) {
				commit("error", e);
				return Promise.reject(e);
			}

			return Promise.resolve();
		}
	},
	getters: {
		loaded(state) {
			return state.loaded;
		},
		messages(state) {
			return state.metadata.messages;
		},
		theme(state) {
			if (state.error || !state.metadata.theme || !state.metadata.theme.primaryColor) {
				return {
					primaryColor: "#a5c100",
					secondaryColor: "#0087a8"
				};
			}

			return state.metadata.theme;
		},
		hasMultipleLanguages(state) {
			return Object.keys(state.languages).length > 1;
		},
		tenantName(state) {
			return state.name;
		},
		languages(state) {
			return state.languages;
		},
		enableNotApplicable(state) {
			return state.metadata.enableNotApplicable;
		}
	}
};
